import React, { useState, useEffect, useContext } from 'react';
import Layout from './Layout';
import HMSTRAIChat from './HMSTRAIChat';
import Footer from './ui/Footer';
import hmsLogoWhite from '../assets/images/IMT_logo.png';
import { AuthContext } from '../context/AuthContext';
import { getAbsoluteMediaUrl } from '../utils/mediaUtils';
import axiosInstance from '../utils/axiosConfig';
import './HMSTRAI.css';

function HMSTRAI() {
  const [chatKey, setChatKey] = useState(0);
  const [currentUserAvatar, setCurrentUserAvatar] = useState(null);
  const { user } = useContext(AuthContext);

  const handleNewChat = () => {
    setChatKey(prevKey => prevKey + 1);
  };

  // Fetch current user avatar
  useEffect(() => {
    const fetchCurrentUserProfile = async () => {
      try {
        const response = await axiosInstance.get('/api/profile/me/');
        
        // API returns nested data: response.data.data.avatar_photo
        const profileData = response.data?.data || response.data;
        
        if (profileData?.avatar_photo) {
          const absoluteAvatarUrl = getAbsoluteMediaUrl(profileData.avatar_photo);
          console.log('✅ HAMSTIR: Avatar loaded:', absoluteAvatarUrl);
          setCurrentUserAvatar(absoluteAvatarUrl);
        } else {
          console.log('⚠️ HAMSTIR: No avatar photo in profile');
        }
      } catch (error) {
        console.error('❌ HAMSTIR: Error fetching avatar:', error);
      }
    };
    
    if (user?.id) {
      fetchCurrentUserProfile();
    }
  }, [user]);

  return (
    <Layout>
      <div className="hmstr-ai-wrapper">
        <div className="hmstr-ai-container">
          {/* HMS Header */}
          <div className="hmstr-header">
            <div className="header-left">
              <img src={hmsLogoWhite} alt="IMT" className="header-logo-img" />
              <h1 className="hms-screen-title">HAMSTIR Interrogator</h1>
            </div>
            
            <div className="header-right">
              <button 
                className="primary-action-btn new-chat-button"
                onClick={handleNewChat}
              >
                New Chat
              </button>
              
              {/* User Avatar */}
              <div className="header-user-avatar">
                {currentUserAvatar && (
                  <img 
                    src={currentUserAvatar} 
                    alt="Your profile" 
                    className="user-avatar-image"
                    onError={(e) => {
                      console.error('❌ Failed to load avatar image:', currentUserAvatar);
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                    onLoad={() => {
                      console.log('✅ Avatar image loaded successfully:', currentUserAvatar);
                    }}
                  />
                )}
                <div 
                  className="user-avatar-initials"
                  style={{ display: currentUserAvatar ? 'none' : 'flex' }}
                >
                  {user?.first_name?.[0] || ''}{user?.last_name?.[0] || ''}
                </div>
              </div>
            </div>
          </div>

          {/* Chat Container */}
          <div className="hmstr-content">
            <div className="floating-element">
              <HMSTRAIChat key={chatKey} isNewChat={true} />
            </div>
          </div>
          
          {/* HMS Footer */}
          <Footer />
        </div>
      </div>
    </Layout>
  );
}

export default HMSTRAI;